/* eslint-disable */

"use client" // Necessário para usar hooks como useState e useEffect no Next.js App Router

import React from "react"

import { useState, useEffect } from "react"
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card"
import { Switch } from "./ui/switch"
import { Button } from "./ui/button"
import { Label } from "./ui/label"
import { Separator } from "./ui/separator"
import { Eye, User, Footprints, Shirt, Layers, Copy, Move, RotateCcw, Save, ChevronDown, Play } from "lucide-react"
// import './Annotation.scss'; // Mantendo o import original, assumindo que você o gerencia
// import __ from './../utils/translation'; // Mantendo o import original, assumindo que você o gerencia
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "./ui/collapsible"

// Placeholder para a função de tradução se não estiver disponível
const __ = (text: string) => text

const golas = [
  {
    id: 1,
    title: "Gola 1",
    thumb: "/models/novos/conjuntos/223/0.jpg",
  },
  {
    id: 2,
    title: "Gola 2",
    thumb: "/models/novos/conjuntos/223/1.jpg",
  },
  {
    id: 3,
    title: "Gola 3",
    thumb: "/models/novos/conjuntos/223/2.jpg",
  },
  {
    id: 4,
    title: "Gola 4",
    thumb: "/models/novos/conjuntos/223/3.jpg",
  },
  {
    id: 5,
    title: "Gola 5",
    thumb: "/models/novos/conjuntos/223/4.jpg",
  },
  {
    id: 6,
    title: "Gola 6",
    thumb: "/models/novos/conjuntos/223/5.jpg",
  },
  {
    id: 7,
    title: "Gola 7",
    thumb: "/models/novos/conjuntos/223/6.jpg",
  },
  {
    id: 8,
    title: "Gola 8",
    thumb: "/models/novos/conjuntos/223/7.jpg",
  },
  {
    id: 9,
    title: "Gola 9",
    thumb: "/models/novos/conjuntos/223/8.jpg",
  },
  {
    id: 10,
    title: "Gola 10",
    thumb: "/models/novos/conjuntos/223/9.jpg",
  },
  {
    id: 11,
    title: "Gola 11",
    thumb: "/models/novos/conjuntos/223/10.jpg",
  },
  {
    id: 12,
    title: "Gola 12",
    thumb: "/models/novos/conjuntos/223/11.jpg",
  },
  {
    id: 13,
    title: "Gola 13",
    thumb: "/models/novos/conjuntos/223/12.jpg",
  },
  {
    id: 14,
    title: "Gola 14",
    thumb: "/models/novos/conjuntos/223/13.jpg",
  },
  {
    id: 15,
    title: "Gola 15",
    thumb: "/models/novos/conjuntos/223/14.jpg",
  },
  {
    id: 16,
    title: "Gola 16",
    thumb: "/models/novos/conjuntos/223/15.jpg",
  },
  {
    id: 17,
    title: "Gola 17",
    thumb: "/models/novos/conjuntos/223/16.jpg",
  },
  {
    id: 18,
    title: "Gola 18",
    thumb: "/models/novos/conjuntos/223/17.jpg",
  },
  {
    id: 19,
    title: "Gola 19",
    thumb: "/models/novos/conjuntos/223/18.jpg",
  },
  {
    id: 20,
    title: "Gola 20",
    thumb: "/models/novos/conjuntos/223/19.jpg",
  },
  {
    id: 21,
    title: "Gola 21",
    thumb: "/models/novos/conjuntos/223/20.jpg",
  },
  {
    id: 22,
    title: "Gola 22",
    thumb: "/models/novos/conjuntos/223/21.jpg",
  },
  {
    id: 23,
    title: "Gola 23",
    thumb: "/models/novos/conjuntos/223/22.jpg",
  },
  {
    id: 24,
    title: "Gola 24",
    thumb: "/models/novos/conjuntos/223/23.jpg",
  },
  {
    id: 25,
    title: "Gola 25",
    thumb: "/models/novos/conjuntos/223/24.jpg",
  },
  {
    id: 26,
    title: "Gola 26",
    thumb: "/models/novos/conjuntos/223/25.jpg",
  },
  {
    id: 27,
    title: "Gola 27",
    thumb: "/models/novos/conjuntos/223/26.jpg",
  },
]

const ObjState = ({ canvas }: { canvas?: unknown }) => {

  const [golaSelecionada, setGolaSelecionada] = useState<number | null>(null)
  const [selectedShirt, setSelectedShirt] = useState<"shirt" | "shirt2" | null>("shirt");



  // Usamos um objeto para gerenciar o estado de cada checkbox individualmente
  const [checkboxes, setCheckboxes] = useState({
    body: true, // Corresponde ao 'AVATAR'
    socks: true, // Corresponde ao 'MEIÃO'
    shirt: true, // Corresponde ao 'camisa'
    shirt2: false,
    shorts: true, // Corresponde ao 'short'
    clone: false,
    calcado: true, // Corresponde ao calçado (bota/calcado)
  })

  // Função genérica para lidar com a mudança de qualquer checkbox
  const handleChange = (e: any) => {
    const { name, checked } = e.target
    setCheckboxes((prev) => ({
      ...prev,
      [name]: checked, // Atualiza apenas a propriedade correspondente ao 'name' do input
    }))

    // Mapeia o 'name' do input para o 'type' e 'id' esperados pela função stateCheck
    let type = ""
    let id = ""
    switch (name) {
      case "body":
        type = "AVATAR"
        id = "state-body-ra"
        break
      case "socks":
        type = "MEIÃO"
        id = "state-socks-ra"
        break
      case "shirt":
        type = "camisa"
        id = "state-shirt-ra"
        break
      case "shirt2":
        type = "camisa2"
        id = "state-shirt2-ra"
        break
      case "shorts":
        type = "short"
        id = "state-short-ra"
        break
      case "calcado":
        type = "calcado"
        id = "state-calcado-ra"
        break
      case "clone":
        type = "clone"
        id = "state-clone"
        break
      default:
        break
    }
    if (type && id) {
      stateCheck(type, checked, id)
    }
  }

  const handleChangeClone = (checked: boolean) => {
    (window as any)["stateClone"](checked)
  }

  // Expõe funções globais para alterar o estado externamente
  useEffect(() => {
    // Certifique-se de que window.obj-type existe antes de usá-lo
    if (typeof window !== "undefined") {
      (window as any).setCheckboxAvatar = (value: any) => {
        setCheckboxes((prev) => {
          const newValue = value === undefined ? !prev.body : value
          stateCheck("AVATAR", newValue, "state-body-ra")
          return { ...prev, body: newValue }
        })
      }
      (window as any).setCheckboxMeiao = (value: any) => {
        setCheckboxes((prev) => {
          const newValue = value === undefined ? !prev.socks : value
          stateCheck("MEIÃO", newValue, "state-socks-ra")
          return { ...prev, socks: newValue }
        })
      }
      (window as any).setCheckboxCamisa = (value: any) => {
        setCheckboxes((prev) => {
          const newValue = value === undefined ? !prev.shirt : value
          stateCheck("camisa", newValue, "state-shirt-ra")
          return { ...prev, shirt: newValue }
        })
      }
      (window as any).setCheckboxCamisa2 = (value: any) => {
        setCheckboxes((prev) => {
          const newValue = value === undefined ? !prev.shirt2 : value
          stateCheck("camisa2", newValue, "state-shirt2-ra")
          return { ...prev, shirt2: newValue }
        })
      }
      (window as any).setCheckboxShort = (value: any) => {
        setCheckboxes((prev) => {
          const newValue = value === undefined ? !prev.shorts : value
          stateCheck("short", newValue, "state-short-ra")
          return { ...prev, shorts: newValue }
        })
      }
      (window as any).setCheckboxClone = (value: any) => {
        setCheckboxes((prev) => {
          const newValue = value === undefined ? !prev.clone : value
          stateCheck("clone", newValue, "state-clone")
          return { ...prev, clone: newValue }
        })
      }
    }

    // Função de limpeza para remover as funções globais quando o componente for desmontado
    return () => {
      if (typeof window !== "undefined") {
        delete (window as any).setCheckboxAvatar
        delete (window as any).setCheckboxMeiao
        delete (window as any).setCheckboxCamisa
        delete (window as any).setCheckboxShort
      }
    }
  }, []) // Array de dependências vazio significa que este efeito roda apenas uma vez na montagem

  function stateCheck(type: any, value: any, id: any) {
    if (type == "clone") {
      (window as any)["stateClone"](value)
    } else if ((window as any)["obj-type"]) {
      localStorage.setItem("check-" + type, value);
      (window as any)["obj-type"](type, value, id)
    } else {
    }
  }

  const selectCollar = function (collar: any) {
    setGolaSelecionada(collar);

    (window as any).currentPose.traverse(function (child: any) {
      if (child.name.includes("GOLA_")) {
        child.visible = false;
      }
    });

    (window as any).currentPose.traverse(function (child: any) {

      var nameIndex = (collar).toString();

      if (collar < 10) nameIndex = "0" + nameIndex;

      if (child.name.includes("GOLA_" + nameIndex)) {
        child.visible = true;
        (window as any).selected_collar = "GOLA_" + nameIndex;
      }
    })
  }

  return (
    <div className="space-y-4 p-2">
      {/* PARTS VISIBILITY */}
      <Card className="border-border/50 bg-card/80 backdrop-blur-sm">
        <CardHeader className="pb-3">
          <CardTitle className="flex items-center gap-2 text-sm font-semibold uppercase tracking-wide">
            <Eye className="h-4 w-4 text-primary" />
            <span
              className="lang"
              data-en="PARTS VISIBILITY"
              data-pt="VISIBILIDADE DAS PARTES"
              data-es="VISIBILIDAD DE PIEZAS"
            >
              {__("PARTS VISIBILITY")}
            </span>
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <div id="options-general" className="space-y-3">
            {/* Body */}
            <div className="flex items-center justify-between rounded-lg bg-muted/50 p-3 transition-colors hover:bg-muted" id="obj-state-body">
              <Label htmlFor="state-body-ra" className="flex cursor-pointer items-center gap-2 text-sm font-medium">
                <User className="h-4 w-4 text-muted-foreground" />
                <span className="lang" data-en="Body" data-pt="Corpo" data-es="Cuerpo">
                  Body
                </span>
              </Label>
              <Switch
                id="state-body-ra"
                checked={checkboxes.body}
                onCheckedChange={(checked) =>
                  handleChange({ target: { name: "body", checked } } as React.ChangeEvent<HTMLInputElement>)
                }
                data-type="AVATAR"
                className="obj-type"
              />
            </div>
            {/* Shirt */}
            <div className="flex items-center justify-between rounded-lg bg-muted/50 p-3 transition-colors hover:bg-muted">
              <Label htmlFor="state-shirt-ra" className="flex cursor-pointer items-center gap-2 text-sm font-medium">
                <Shirt className="h-4 w-4 text-muted-foreground" />
                <span className="lang" data-en="Shirt" data-pt="Camisa Curta" data-es="Camisa">
                  Shirt
                </span>
              </Label>
              {/**<Switch
                id="state-shirt-ra"
                checked={checkboxes.shirt}
                onCheckedChange={(checked) =>
                  handleChange({ target: { name: "shirt", checked } } as React.ChangeEvent<HTMLInputElement>)
                }
                data-type="camisa"
                className="obj-type"
              /> */}
              <Switch
                id="state-shirt-ra"
                checked={selectedShirt === "shirt"}
                data-type="camisa"
                className="obj-type"
                onCheckedChange={(checked) => {
                  handleChange({
                    target: { name: "shirt", checked },
                  } as React.ChangeEvent<HTMLInputElement>);

                  handleChange({
                    target: { name: "shirt2", checked: !checked },
                  } as React.ChangeEvent<HTMLInputElement>);

                  setSelectedShirt(checked ? "shirt" : null)
                }}
              />
            </div>

            {/* Shirt 2*/}
            <div className="flex items-center justify-between rounded-lg bg-muted/50 p-3 transition-colors hover:bg-muted">
              <Label htmlFor="state-shirt2-ra" className="flex cursor-pointer items-center gap-2 text-sm font-medium">
                <Shirt className="h-4 w-4 text-muted-foreground" />
                <span className="lang" data-en="Shirt 2" data-pt="Camisa Longa" data-es="Camisa 2">
                  Shirt 2
                </span>
              </Label>
              {/**<Switch
                id="state-shirt2-ra"
                checked={checkboxes.shirt2}
                onCheckedChange={(checked) =>
                  handleChange({ target: { name: "shirt2", checked } } as React.ChangeEvent<HTMLInputElement>)
                }
                data-type="camisa2"
                className="obj-type"
              /> */}
              <Switch
                id="state-shirt2-ra"
                checked={selectedShirt === "shirt2"}
                data-type="camisa2"
                className="obj-type"
                onCheckedChange={(checked) => {
                  handleChange({
                    target: { name: "shirt2", checked },
                  } as React.ChangeEvent<HTMLInputElement>);

                  handleChange({
                    target: { name: "shirt", checked: !checked },
                  } as React.ChangeEvent<HTMLInputElement>);

                  setSelectedShirt(checked ? "shirt2" : null)
                }}
              />
            </div>

            {/* Shorts */}
            <div className="flex items-center justify-between rounded-lg bg-muted/50 p-3 transition-colors hover:bg-muted">
              <Label htmlFor="state-short-ra" className="flex cursor-pointer items-center gap-2 text-sm font-medium">
                <Layers className="h-4 w-4 text-muted-foreground" />
                <span className="lang" data-en="Shorts" data-pt="Calção" data-es="Calção">
                  Shorts
                </span>
              </Label>
              <Switch
                id="state-short-ra"
                checked={checkboxes.shorts}
                onCheckedChange={(checked) =>
                  handleChange({ target: { name: "shorts", checked } } as React.ChangeEvent<HTMLInputElement>)
                }
                data-type="short"
                className="obj-type"
              />
            </div>

            {/* SHoes */}
            <div className="flex items-center justify-between rounded-lg bg-muted/50 p-3 transition-colors hover:bg-muted">
              <Label htmlFor="state-calcado-ra" className="flex cursor-pointer items-center gap-2 text-sm font-medium">
                <Footprints className="h-4 w-4 text-muted-foreground" />
                <span>
                  Calçado
                </span>
              </Label>
              <Switch
                id="state-calcado-ra"
                checked={checkboxes.calcado}
                onCheckedChange={(checked) =>
                  handleChange({ target: { name: "calcado", checked } } as React.ChangeEvent<HTMLInputElement>)
                }
                data-type="MEIÃO"
                className="obj-type"
              />
            </div>


            {/* Socks */}
            <div className="flex items-center justify-between rounded-lg bg-muted/50 p-3 transition-colors hover:bg-muted">
              <Label htmlFor="state-socks-ra" className="flex cursor-pointer items-center gap-2 text-sm font-medium">
                <Footprints className="h-4 w-4 text-muted-foreground" />
                <span className="lang" data-en="Socks" data-pt="Meias" data-es="Meias">
                  Meias
                </span>
              </Label>
              <Switch
                id="state-socks-ra"
                checked={checkboxes.socks}
                onCheckedChange={(checked) =>
                  handleChange({ target: { name: "socks", checked } } as React.ChangeEvent<HTMLInputElement>)
                }
                data-type="MEIÃO"
                className="obj-type"
              />
            </div>

          </div>


          <Collapsible>
            <CollapsibleTrigger asChild>
              <Button
                id="collars-fifa"
                variant="outline"
                className="w-full flex justify-between items-center hidden"
              >
                Escolher gola
                <ChevronDown className="h-4 w-4" />
              </Button>
            </CollapsibleTrigger>

            <CollapsibleContent className="mt-3 space-y-2">
              {golas.map((gola) => {
                const ativo = golaSelecionada === gola.id

                return (
                  <button
                    key={gola.id}
                    onClick={() => selectCollar(gola.id)}
                    className={`
              flex items-center gap-3 w-full rounded-md border p-2 transition
              ${ativo
                        ? "border-primary bg-primary/10 ring-1 ring-primary"
                        : "border-border/50 bg-background/60 hover:bg-accent"
                      }
            `}
                  >
                    <img
                      src={gola.thumb}
                      alt={gola.title}
                      className="h-20 w-20 rounded object-cover"
                    />

                    <span
                      className={`text-sm font-medium ${ativo ? "text-primary" : ""
                        }`}
                    >
                      {gola.title}
                    </span>
                  </button>
                )
              })}
            </CollapsibleContent>
          </Collapsible>

        </CardContent>
      </Card>

      {/* FÍSICA 
      <Card className="border-border/50 bg-card/80 backdrop-blur-sm">
        <CardHeader className="pb-3">
          <CardTitle className="flex items-center gap-2 text-sm font-semibold uppercase tracking-wide fisica">
            <Layers className="h-4 w-4 text-primary" />
            {__("FÍSICA")}
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div id="options-general" className="fisica">
            <div className="flex items-center justify-between rounded-lg bg-muted/50 p-3 transition-colors hover:bg-muted">
              <Label htmlFor="state-fisica" className="cursor-pointer text-sm font-medium">
                Estado Física
              </Label>
              <Switch id="state-fisica" />
            </div>
          </div>
        </CardContent>
      </Card>*/}

      {/* CLONE */}
      <Card className="border-border/50 bg-card/80 backdrop-blur-sm">
        <CardHeader className="pb-3">
          <CardTitle className="flex items-center gap-2 text-sm font-semibold uppercase tracking-wide">
            <Copy className="h-4 w-4 text-primary" />
            {__("CLONE")}
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <div id="options-general" className="space-y-3">
            <div className="flex items-center justify-between rounded-lg bg-muted/50 p-3 transition-colors hover:bg-muted">
              <Label htmlFor="state-clone" className="cursor-pointer text-sm font-medium">
                Estado Clone
              </Label>
              <Switch
                id="state-clone"
                checked={checkboxes.clone}
                onCheckedChange={(checked) =>
                  handleChange({ target: { name: "clone", checked } } as React.ChangeEvent<HTMLInputElement>)
                } />
            </div>

            <div className="flex items-center justify-between rounded-lg bg-muted/50 p-3 transition-colors hover:bg-muted cloneOpt">
              <Label htmlFor="state-trans" className="cursor-pointer text-sm font-medium">
                Estado das Flechas
              </Label>
              <Switch id="state-trans" />
            </div>

            <Separator className="my-2" />

            <div className="flex gap-2">
              <Button id="state-pos" variant="outline" size="sm" className="flex-1 cloneOpt bg-transparent">
                <Move className="mr-2 h-4 w-4" />
                Mode Mover
              </Button>
              <Button id="state-rot" variant="outline" size="sm" className="flex-1 cloneOpt bg-transparent">
                <RotateCcw className="mr-2 h-4 w-4" />
                Mode Rotacionar
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* ANIMATIONS */}
      <Card className="hidden border-border/50 bg-card/80 backdrop-blur-sm" id='menu-anim-controls'>
        <CardHeader className="pb-3">
          <CardTitle className="flex items-center gap-2 text-sm font-semibold uppercase tracking-wide">
            <Play className="h-4 w-4 text-primary" />
            {__("CONTROLES DE ANIMAÇÕES")}
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-3 overflow-y-auto max-h-[200px]" id="animations-options">
          <div className="flex m-2">
            <label className="m-2">Estado</label>
            <i id='state-anim2' className="fas fa-play m-2"></i>
          </div>
          <div className="flex m-2">
            <label className="m-2">Tempo</label>
            <input className="m-2" type="range" id="anim-time" name="animação tempo" min="0" max="1" defaultValue={0} step="0.01" />
          </div>
          <div className="flex m-2">
            <label className="m-2">Velocidade</label>
            <input className="m-2" type="range" id="anim-speed" name="animação velocidade" min="0" max="1" defaultValue={0} step="0.01" />
          </div>
        </CardContent>
      </Card>
      <Card className="hidden border-border/50 bg-card/80 backdrop-blur-sm" id="card-animations">
        <CardHeader className="pb-3">
          <CardTitle className="flex items-center gap-2 text-sm font-semibold uppercase tracking-wide">
            <Play className="h-4 w-4 text-primary" />
            {__("ANIMAÇÕES")}
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-3 overflow-y-auto max-h-[200px] grid grid-cols-2 gap-4" id="animations-options">
          <div data-anim="1" className="flex items-center justify-between rounded-lg bg-muted/50 p-3 transition-colors hover:bg-muted flex-col">
            <img src="./animations/1.webp" height={100} width={100}></img>
            <Label className="cursor-pointer text-sm font-medium">
              Pose A
            </Label>
          </div>
          <div data-anim="2" className="flex items-center justify-between rounded-lg bg-muted/50 p-3 transition-colors hover:bg-muted flex-col !m-0">
            <img src="./animations/2.webp" height={100} width={100}></img>
            <Label className="cursor-pointer text-sm font-medium">
              Pose Padrão
            </Label>
          </div>
          <div data-anim="3" className="flex items-center justify-between rounded-lg bg-muted/50 p-3 transition-colors hover:bg-muted flex-col !m-0">
            <video
              className="h-[100px] w-[100px] object-cover"
              width="100"
              height={100}
              autoPlay
              loop
              muted
            >
              <source src="./animations/3.mp4" type="video/mp4" />
            </video>
            <Label className="cursor-pointer text-sm font-medium">
              Botão
            </Label>
          </div>
          <div data-anim="4" className="flex items-center justify-between rounded-lg bg-muted/50 p-3 transition-colors hover:bg-muted  flex-col !m-0">
            <video
              className="h-[100px] w-[100px] object-cover"
              width="100"
              height={100}
              autoPlay
              loop
              muted
            >
              <source src="./animations/4.mp4" type="video/mp4" />
            </video>
            <Label className="cursor-pointer text-sm font-medium">
              Bêbado
            </Label>
          </div>
          <div data-anim="5" className="flex items-center justify-between rounded-lg bg-muted/50 p-3 transition-colors hover:bg-muted flex-col !m-0">
            <video
              className="h-[100px] w-[100px] object-cover"
              width="100"
              height={100}
              autoPlay
              loop
              muted
            >
              <source src="./animations/5.mp4" type="video/mp4" />
            </video>
            <Label className="cursor-pointer text-sm font-medium">
              Pescando
            </Label>
          </div>
          <div data-anim="6" className="flex items-center justify-between rounded-lg bg-muted/50 p-3 transition-colors hover:bg-muted flex-col !m-0">
            <video
              className="h-[100px] w-[100px] object-cover"
              width="100"
              height={100}
              autoPlay
              loop
              muted
            >
              <source src="./animations/6.mp4" type="video/mp4" />
            </video>
            <Label className="cursor-pointer text-sm font-medium">
              Luta
            </Label>
          </div>
          <div data-anim="7" className="flex items-center justify-between rounded-lg bg-muted/50 p-3 transition-colors hover:bg-muted flex-col !m-0">
            <video
              className="h-[100px] w-[100px] object-cover"
              width="100"
              height={100}
              autoPlay
              loop
              muted
            >
              <source src="./animations/7.mp4" type="video/mp4" />
            </video>
            <Label className="cursor-pointer text-sm font-medium">
              Aqueçendo
            </Label>
          </div>
          <div data-anim="8" className="flex items-center justify-between rounded-lg bg-muted/50 p-3 transition-colors hover:bg-muted flex-col !m-0">
            <video
              className="h-[100px] w-[100px] object-cover"
              width="100"
              height={100}
              autoPlay
              loop
              muted
            >
              <source src="./animations/8.mp4" type="video/mp4" />
            </video>
            <Label className="cursor-pointer text-sm font-medium">
              Correndo
            </Label>
          </div>
          <div data-anim="9" className="flex items-center justify-between rounded-lg bg-muted/50 p-3 transition-colors hover:bg-muted flex-col !m-0">
            <video
              className="h-[100px] w-[100px] object-cover"
              width="100"
              height={100}
              autoPlay
              loop
              muted
            >
              <source src="./animations/9.mp4" type="video/mp4" />
            </video>
            <Label className="cursor-pointer text-sm font-medium">
              Parado
            </Label>
          </div>
          <div data-anim="10" className="flex items-center justify-between rounded-lg bg-muted/50 p-3 transition-colors hover:bg-muted flex-col !m-0">
            <video
              className="h-[100px] w-[100px] object-cover"
              width="100"
              height={100}
              autoPlay
              loop
              muted
            >
              <source src="./animations/10.mp4" type="video/mp4" />
            </video><Label className="cursor-pointer text-sm font-medium">
              360
            </Label>
          </div>
          <div data-anim="11" className="flex items-center justify-between rounded-lg bg-muted/50 p-3 transition-colors hover:bg-muted flex-col !m-0">
            <video
              className="h-[100px] w-[100px] object-cover"
              width="100"
              height={100}
              autoPlay
              loop
              muted
            >
              <source src="./animations/11.mp4" type="video/mp4" />
            </video>
            <Label className="cursor-pointer text-sm font-medium">
              Andando
            </Label>
          </div>
        </CardContent>
      </Card>

      {/* PREDEFINIÇÕES 
      <Card className="border-border/50 bg-card/80 backdrop-blur-sm">
        <CardHeader className="pb-3">
          <CardTitle className="flex items-center gap-2 text-sm font-semibold uppercase tracking-wide">
            <Save className="h-4 w-4 text-primary" />
            {__("PREDEFINIÇÕES")}
          </CardTitle>
        </CardHeader>
        <CardContent>
          <Button id="register-presets" className="w-full" variant="default">
            <Save className="mr-2 h-4 w-4" />
            Salvar Predefinições
          </Button>
        </CardContent>
      </Card>*/}
    </div>
  )
}

export default ObjState
